import update from 'immutability-helper';
import _ from 'lodash';
import { Action } from '../../redux.types';
import { PERMISSIONS_ACTION_NAMES } from '../permissions.actions';
import { RawPermission, RevisionsState } from '../permissions.types';

const defaultState: RevisionsState = {
  itemsMap: {},
  numbersList: {},
  loaded: {},
};

export const revisions = (
  state: RevisionsState = defaultState,
  { type, payload }: Action,
): RevisionsState => {
  switch (type) {
    case PERMISSIONS_ACTION_NAMES.LOAD_PERMISSIONS_SUCCESS: {
      return _.reduce(
        payload.responsePayload,
        (acc, permission: RawPermission) => {
          acc.itemsMap[permission.id] = {
            [permission.activeRevision.number]: permission.activeRevision,
          };
          acc.numbersList[permission.id] = [permission.activeRevision.number];
          acc.loaded[permission.id] = false;

          return acc;
        },
        state,
      );
    }

    case PERMISSIONS_ACTION_NAMES.CREATE_PERMISSION_SUCCESS: {
      const permission = payload.responsePayload;
      const activeRevisionNumber = permission.activeRevision.number;

      return {
        itemsMap: update(state.itemsMap, {
          $merge: {
            [permission.id]: {
              [activeRevisionNumber]: permission.activeRevision,
            },
          },
        }),
        numbersList: update(state.numbersList, {
          $merge: { [permission.id]: [activeRevisionNumber] },
        }),
        loaded: update(state.loaded, { $merge: { [permission.id]: false } }),
      };
    }

    case PERMISSIONS_ACTION_NAMES.LOAD_REVISIONS_SUCCESS: {
      const { permissionId } = payload.additionalData;
      const itemsMap = _.keyBy(payload.responsePayload, 'number');
      const numbersList = _(itemsMap).keys().map(_.toNumber).value();

      return {
        itemsMap: update(state.itemsMap, {
          $merge: { [permissionId]: itemsMap },
        }),
        numbersList: update(state.numbersList, {
          $merge: { [permissionId]: numbersList },
        }),
        loaded: update(state.loaded, { $merge: { [permissionId]: true } }),
      };
    }

    case PERMISSIONS_ACTION_NAMES.CREATE_REVISION_SUCCESS: {
      const { permissionId } = payload.additionalData;
      const revision = payload.responsePayload;

      return {
        ...state,
        numbersList: update(state.numbersList, {
          $merge: {
            [permissionId]: [
              ...state.numbersList[permissionId],
              revision.number,
            ],
          },
        }),
        itemsMap: update(state.itemsMap, {
          [permissionId]: {
            $merge: { ..._.keyBy([revision], 'number') },
          },
        }),
      };
    }

    default: {
      return state;
    }
  }
};
